export default "__VITE_ASSET__BF92hpWi__"